export const randInt = (max) => { return Math.floor(Math.random() * max) }
export const sleep = (ms) => { return new Promise(resolve => setTimeout(resolve, ms)); }

export const newBoard = (size) => {
  var res = []
  for (var i = 0; i < size; i++) {
    var row = []
    for (var j = 0; j < size; j++) row.push(0);
    res.push(row);
  }
  return res;
}

export const encodeBoard = (board) => {
  var res = "" + board.length
  for (var i = 0; i < board.length; i++) {
    for (var j = 0; j < board.length; j++) {
      if (board[i][j]) res += "1";
      else res += "0"
    }
  }
  return res
}

export const decodeBoard = (encoding) => {
  const size = parseInt(encoding[0])
  var res = []
  for (var i = 0; i < size; i++) {
    var row = []
    for (var j = 0; j < size; j++) {
      if (encoding[size * i + j + 1] === '1') row.push(1)
      else row.push(0)
    }
    res.push(row)
  }
  return res
}

export const performFlip = (r, c, data) => {
  for (var dr = -1; dr <= 1; dr++) {
    if (r + dr < 0 || r + dr >= data.length) continue
    for (var dc = -1; dc <= 1; dc++) {
      if (c + dc < 0 || c + dc >= data.length) continue;
      data[r + dr][c + dc] ^= 1
    }
  }
}
